import axios from "@/utils/request"

export const loadThemes = (params) => {
  return axios.request({
    url: "live/theme/list",
    method: "GET",
    params,
  });
};

export const getTheme = (params) => {
  return axios.request({
    url: "live/theme/detail",
    method: "GET",
    params,
  });
};

export const loadTopics = (params) => {
  return axios.request({
    url: "live/topic/list",
    method: "GET",
    params,
  });
};

export const onZan = (data) => {
  return axios.request({
    url: "live/zan/add",
    method: "POST",
    data,
  });
};

export const delZan = (data) => {
  return axios.request({
    url: "live/zan/delete",
    method: "POST",
    data
  })
}

export const addComment = (data) => {
  return axios.request({
    url: "live/comment/add",
    method: "POST",
    data
  })
}

export const loadComments = (params) => {
  return axios.request({
    url: "live/comment/list",
    method: "GET",
    params,
  });
};

export const loadQiandaoItems = (params) => {
  return axios.request({
    url: "live/qiandao_item/list",
    method: "GET",
    params,
  });
};

export const loadSignPhb = (params) => {
  return axios.request({
    url: "live/sign/phb",
    method: "GET",
    params,
  });
};

export const addSign = (data) => {
  return axios.request({
    url: "live/sign/add",
    method: "POST",
    data
  })
}

export const getSign = (params) => {
  return axios.request({
    url: "live/sign/detail",
    method: "GET",
    params
  })
}

export const addTopic = (data) => {
  return axios.request({
    url: "live/topic/add",
    method: "POST",
    data
  })
}

export const getPersonal = (params) => {
  return axios.request({
    url: "live/personal/isBind",
    method: "GET",
    params
  })
}

export const addPersonal = (data) => {
  return axios.request({
    url: "live/personal/add",
    method: "POST",
    data
  })
}

export const loadNewestTopics = (params) => {
  return axios.request({
    url: "live/topic/newest",
    method: "GET",
    params
  })
}

export const loadOldestTopics = (params) => {
  return axios.request({
    url: "live/topic/oldest",
    method: "GET",
    params
  })
}

export const addViews = (data) => {
  return axios.request({
    url: "live/theme/addViews",
    method: "POST",
    data
  })
}

export const addLikes = (data) => {
  return axios.request({
    url: "live/theme/addLikes",
    method: "POST",
    data
  })
}

export const loadNewestLiuyans = (params) => {
  return axios.request({
    url: "live/liuyan/newest",
    method: "GET",
    params
  })
}

export const loadOldestLiuyans = (params) => {
  return axios.request({
    url: "live/liuyan/oldest",
    method: "GET",
    params
  })
}

export const addLiuyan = (data) => {
  return axios.request({
    url: "live/liuyan/add",
    method: "POST",
    data,
  });
};

export const loadPrizies = (params) => {
  return axios.request({
    url: "live/prize/list",
    method: "GET",
    params
  })
}

export const getPrizeRand = (params) => {
  return axios.request({
    url: "live/prize/rand",
    method: "GET",
    params
  })
}

export const addPrizeRecord = (data) => {
  return axios.request({
    url: "live/prizerecord/add",
    method: "POST",
    data,
  });
};

export const addPrizeWinner = (data) => {
  return axios.request({
    url: "live/prizewinner/add",
    method: "POST",
    data,
  })
}

export const getMyPrize = (params) => {
  return axios.request({
    url: "live/prizewinner/get",
    method: "GET",
    params
  })
}

export const loadChildVideo = (params) => {
  return axios.request({
    url: "live/childvideo/list",
    method: "GET",
    params
  })
}

export const loadOneVote = (params) => {
  return axios.request({
    url: "live/vote/one",
    method: "GET",
    params
  })
}

export const loadAllVoteItems = (params) => {
  return axios.request({
    url: "live/voteitem/list",
    method: "GET",
    params
  })
}

export const loadVoteRecord = (params) => {
  return axios.request({
    url: "live/voterecord/record",
    method: "GET",
    params
  })
}

export const addVoteRecord = (data) => {
  return axios.request({
    url: "live/voterecord/add",
    method: "POST",
    data
  })
}
